module.exports = __webpack_public_path__ + "img/qinghai.041c1645.jpg";